"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockTopSection = void 0;
var React = require("react");
var BlockTopGallery_1 = require("@/pages/place/components/BlockTopGallery");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var PlaceFollowButton_1 = require("@/pages/place/components/PlaceFollowButton");
var PlaceAvailable_1 = require("@/pages/place/components/PlaceAvailable");
var format_1 = require("@/utils/format");
var classNames = require("classnames");
var PlaceFeatures_1 = require("@/utils/PlaceFeatures");
var marked_1 = require("marked");
exports.blockTopSection = function (props) {
    var nameFull = props.lang.toLowerCase() === 'en-us'
        ? props.name + " " + (props.name === props.nameAlt ? '' : props.nameAlt)
        : props.nameAlt + " " + (props.name === props.nameAlt ? '' : props.name);
    var forText = props.type === SfilterTypeGroup_1.SfilterType.ALL
        ? props.t.forAll
        : props.type === SfilterTypeGroup_1.SfilterType.BUY
            ? props.t.forSale
            : props.t.forRent;
    var renderAge = function (props) {
        var ageRow = props.keyDetails.find(function (it) { return it.name === 'blockAge'; });
        return (React.createElement("div", { className: "c-place__overview-cell" },
            React.createElement("h3", { className: "c-place__overview-label" }, props.t.age),
            React.createElement("div", { className: "c-place__overview-text" },
                React.createElement("span", { className: "c-place__overview-value" }, (ageRow && Number(ageRow.text)) ? format_1.default.comma(Number(ageRow.text)) : '-'),
                "\u00A0",
                React.createElement("span", { className: "c-place__overview-unit" }, props.t.year))));
    };
    var renderSize = function (props) {
        var maxSizeRow = props.keyDetails.find(function (it) { return it.name === 'unitMaxSize'; });
        var minSizeRow = props.keyDetails.find(function (it) { return it.name === 'unitMinSize'; });
        var rangeStr = '-';
        if (minSizeRow && maxSizeRow) {
            rangeStr = format_1.default.comma(Number(minSizeRow.text)) + " - " + format_1.default.comma(Number(maxSizeRow.text));
        }
        else if (minSizeRow) {
            rangeStr = "" + format_1.default.comma(Number(minSizeRow.text));
        }
        else if (maxSizeRow) {
            rangeStr = "" + format_1.default.comma(Number(maxSizeRow.text));
        }
        return (React.createElement("div", { className: "c-place__overview-cell" },
            React.createElement("div", { className: "c-place__overview-label" }, props.t.unitRange),
            React.createElement("div", { className: "c-place__overview-text" },
                React.createElement("span", { className: "c-place__overview-value" }, rangeStr),
                "\u00A0",
                React.createElement("span", { className: "c-place__overview-unit" }, props.t.sqft))));
    };
    var renderNoOfBlocks = function (props) {
        var totalBlockRow = props.keyDetails.find(function (it) { return it.name === 'totalBlock'; });
        return (React.createElement("div", { className: "c-place__overview-cell" },
            React.createElement("div", { className: "c-place__overview-label" }, props.t.totalBlock),
            React.createElement("div", { className: "c-place__overview-text" },
                React.createElement("span", { className: "c-place__overview-value" }, totalBlockRow && Number(totalBlockRow.text) ? format_1.default.comma(Number(totalBlockRow.text)) : '-'),
                "\u00A0",
                React.createElement("span", { className: "c-place__overview-unit" }, props.t.blocks))));
    };
    var renderFactAge = function (props) {
        var ageRow = props.keyDetails.find(function (it) { return it.name === 'blockAge'; });
        if (!ageRow)
            return null;
        return (React.createElement("div", { className: "c-place__fact u-mobile-only" },
            React.createElement("h3", { className: "c-place__fact-label" }, props.t.age),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, format_1.default.comma(Number(ageRow.text))),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.year))));
    };
    var renderFactSizeRange = function (props) {
        var maxSizeRow = props.keyDetails.find(function (it) { return it.name === 'unitMaxSize'; });
        var minSizeRow = props.keyDetails.find(function (it) { return it.name === 'unitMinSize'; });
        if (!maxSizeRow)
            return null;
        var rangeStr = minSizeRow ?
            format_1.default.comma(Number(minSizeRow.text)) + " - " + format_1.default.comma(Number(maxSizeRow.text)) :
            "" + format_1.default.comma(Number(maxSizeRow.text));
        return (React.createElement("div", { className: "c-place__fact u-mobile-only" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.unitRange),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, rangeStr),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.sqft))));
    };
    var renderFactNoOfBlocks = function (props) {
        var totalBlockRow = props.keyDetails.find(function (it) { return it.name === 'totalBlock'; });
        if (!totalBlockRow)
            return null;
        return (React.createElement("div", { className: "c-place__fact u-mobile-only" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.totalBlock),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, format_1.default.comma(Number(totalBlockRow.text))),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.blocks))));
    };
    var renderFactBlockType = function (props) {
        var row = props.keyDetails.find(function (it) { return it.name === 'rise'; });
        if (!row)
            return null;
        return (React.createElement("div", { className: "c-place__fact" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.rise),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, row.text))));
    };
    var renderFactNoOfUnits = function (props) {
        var row = props.keyDetails.find(function (it) { return it.name === 'totalUnit'; });
        if (!row || !Number(row.text))
            return null;
        return (React.createElement("div", { className: "c-place__fact" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.totalUnit),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, format_1.default.comma(Number(row.text))),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.units))));
    };
    var renderFactNoOfFloors = function (props) {
        var _a;
        var row = props.keyDetails.find(function (it) { return it.name === 'floorPerBlock'; });
        if (!row)
            return null;
        if (!row.text.trim())
            return null;
        var str = row.text;
        var floorMin = 0;
        var floorMax = 0;
        if (str.indexOf('-') >= 0) {
            _a = str.split('-').map(function (it) { return Number(it.trim()); }), floorMin = _a[0], floorMax = _a[1];
        }
        else {
            floorMax = Number(str.trim());
        }
        if (!floorMax)
            return null;
        var floorRangeStr = floorMin ?
            format_1.default.comma(floorMin) + " - " + format_1.default.comma(floorMax) :
            "" + format_1.default.comma(floorMax);
        return (React.createElement("div", { className: "c-place__fact" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.floorPerBlock),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, floorRangeStr),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.floors))));
    };
    var renderFactNoOfUnitsFloor = function (props) {
        var _a;
        var row = props.keyDetails.find(function (it) { return it.name === 'unitPerBlock'; });
        if (!row)
            return null;
        if (!row.text.trim())
            return null;
        var str = row.text;
        var unitsMin = 0;
        var unitsMax = 0;
        if (str.indexOf('-') >= 0) {
            _a = str.split('-').map(function (it) { return Number(it.trim()); }), unitsMin = _a[0], unitsMax = _a[1];
        }
        else {
            unitsMax = Number(str.trim());
        }
        if (!unitsMax)
            return null;
        var unitsPerFloorRangeStr = unitsMin ?
            format_1.default.comma(unitsMin) + " - " + format_1.default.comma(unitsMax) :
            "" + format_1.default.comma(unitsMax);
        return (React.createElement("div", { className: "c-place__fact" },
            React.createElement("div", { className: "c-place__fact-label" }, props.t.unitPerFloor),
            React.createElement("div", { className: "c-place__fact-text" },
                React.createElement("span", { className: "c-place__fact-value" }, unitsPerFloorRangeStr),
                "\u00A0",
                React.createElement("span", { className: "c-place__fact-unit" }, props.t.units))));
    };
    var factKeys = ['blockAge', 'unitMaxSize', 'totalBlock', 'rise', 'totalUnit', 'floorPerBlock', 'unitPerBlock'];
    var factCounts = props.keyDetails.filter(function (it) { return factKeys.indexOf(it.name) >= 0; }).length;
    var factMoreClass = classNames('l-building__facts', {
        'l-building__facts--more': factCounts > 4 && !props.factsMore,
    });
    var renderFacilities = function (props) {
        if (!props.features || !props.features.length)
            return null;
        var renderFacility = function (id, i) {
            var feature = PlaceFeatures_1.toFeature(id);
            if (!feature)
                return '';
            var icon = classNames([
                'fa',
                "fa-" + feature.icon,
            ]);
            return (React.createElement("div", { className: "c-place__amenity" },
                React.createElement("span", { key: i, className: "c-place__amenity-label" },
                    React.createElement("span", { className: icon })),
                React.createElement("span", { className: "c-place__amenity-value" }, props.tFeature[feature.key] ? props.tFeature[feature.key] : feature.key)));
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "c-place__amenities" }, props.features.map(renderFacility)),
            props.features.length > 4 ? (React.createElement("div", { className: "c-place__amenity-more" },
                React.createElement("a", { onClick: props.forceFeaturesViewMore, className: "o-btn o-btn--flat" }, props.t.viewMore))) : null));
    };
    var facilitiesClass = classNames('l-building__amenities', {
        'l-building__amenities--more': props.features && props.features.length > 4 && props.featuresMore,
    });
    var descriptionClass = classNames('l-building__description', {
        'l-building__description--more': props.aboutMoreTextDisplay,
    });
    var mapSearchUrl = props.type === SfilterTypeGroup_1.SfilterType.BUY ?
        props.mapSearchBuyLink : props.mapSearchRentLink;
    var districtSearchUrl = props.type === SfilterTypeGroup_1.SfilterType.BUY ?
        props.viewSaleLinkOfDistrict : props.viewRentLinkOfDistrict;
    var renderDescription = function (props) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "c-place__description", dangerouslySetInnerHTML: { __html: marked_1.marked.parse(props.about) } }),
            props.aboutMore ? (React.createElement("div", null,
                React.createElement("a", { className: "o-btn o-btn--flat", onClick: props.forceAboutViewMore }, props.aboutMoreTextDisplay ? props.t.viewLess : props.t.viewMore))) : null));
    };
    var blockName = props.name + (props.name === props.nameAlt ? '' : ' ' + props.nameAlt);
    return (React.createElement("div", { className: "l-building__head" },
        React.createElement("div", { className: "l-building__header" },
            React.createElement("div", { className: "l-building__title" },
                React.createElement("h1", { style: { display: 'inline-block' }, className: "c-building__name" }, blockName)),
            React.createElement("div", { className: "l-building__actions" },
                React.createElement(PlaceFollowButton_1.placeFollowButton, __assign({}, PlaceAvailable_1.propsToAvailableProps(props, props.type), { followClicked: props.followClicked, unfollowClicked: props.unfollowClicked })),
                React.createElement("button", { onClick: props.onEnquireClicked, className: "c-building__action o-btn o-btn--cta" },
                    React.createElement("span", { className: "fal fa-envelope" }),
                    "\u00A0",
                    props.t.contactAgent))),
        React.createElement("div", { className: "l-building__caption" },
            React.createElement("div", { className: "c-building__caption" },
                React.createElement("h2", null, nameFull + " " + forText))),
        React.createElement("div", { className: "l-building__body" },
            React.createElement("div", { className: "l-building__img" },
                React.createElement(BlockTopGallery_1.default, { items: props.galleryItems, regionName: props.district, location: { lat: props.lat, lng: props.lng }, slideIndex: props.galleryIndex, googleApikey: props.googleApikey, mapReady: props.mapReady, onItemClick: function (item) { return props.onGalleryItemClicked(item.src); }, onMapClick: props.onGalleryMapClicked, onSlideIndexChanged: props.setGalleryIndex, setBlockTopGalleryScroll: props.setTopGalleryScroll })),
            React.createElement("div", { className: "l-building__info" },
                React.createElement("div", { className: "l-building__overview" },
                    React.createElement("div", { className: "c-place__overview" },
                        renderAge(props),
                        renderSize(props),
                        renderNoOfBlocks(props))),
                React.createElement("div", { className: "l-building__search" },
                    React.createElement("div", { className: "c-place__searchbox" },
                        React.createElement("a", { target: "_blank", href: props.viewSaleLink, className: "c-place__searchbox-item" },
                            React.createElement("span", { className: "fal fa-search" }),
                            "\u00A0",
                            React.createElement("span", { className: "c-place__searchbox-item-label" }, props.t.forSale),
                            "\u00A0",
                            props.availablePropertiesSale.length ? (React.createElement("span", { className: "c-place__searchbox-item-count" },
                                "(",
                                props.availablePropertiesSale.length,
                                ")")) : null),
                        React.createElement("a", { target: "_blank", href: props.viewRentLink, className: "c-place__searchbox-item" },
                            React.createElement("span", { className: "fal fa-search" }),
                            "\u00A0",
                            React.createElement("span", { className: "c-place__searchbox-item-label" }, props.t.forRent),
                            "\u00A0",
                            props.availablePropertiesRent.length ? (React.createElement("span", { className: "c-place__searchbox-item-count" },
                                "(",
                                props.availablePropertiesRent.length,
                                ")")) : null))),
                React.createElement("div", { className: "l-building__address" },
                    React.createElement("div", { className: "c-place__location" },
                        React.createElement("div", { className: "c-place__location-label" }, props.t.viewOnMap),
                        React.createElement("div", { className: "c-place__location-info" },
                            React.createElement("div", { className: "c-place__location-icon" },
                                React.createElement("span", { className: "fal fa-map-marker-alt" })),
                            React.createElement("a", { href: mapSearchUrl, className: "c-place__location-text" },
                                props.address,
                                " \u00A0"),
                            React.createElement("div", { className: "c-place__location-icon" },
                                React.createElement("span", { className: "fal fa-external-link" }))),
                        React.createElement("div", { className: "c-place__location-district" },
                            React.createElement("a", { className: "c-place__location-district-btn", href: districtSearchUrl },
                                React.createElement("span", { className: "fal fa-search" }),
                                "\u00A0 ",
                                format_1.default.print(props.t.viewDistrict, [props.district]))))),
                React.createElement("div", { className: factMoreClass },
                    React.createElement("div", { className: "c-place__facts" },
                        renderFactAge(props),
                        renderFactSizeRange(props),
                        renderFactNoOfBlocks(props),
                        renderFactBlockType(props),
                        renderFactNoOfUnits(props),
                        renderFactNoOfFloors(props),
                        renderFactNoOfUnitsFloor(props)),
                    React.createElement("div", { className: "c-place__facts-more" },
                        React.createElement("a", { className: "o-btn o-btn--flat", onClick: props.forceFactsViewMore }, props.t.viewMore))),
                React.createElement("div", { className: facilitiesClass }, renderFacilities(props)))),
        React.createElement("div", { className: descriptionClass }, props.about ? renderDescription(props) : null)));
};
;
